import _extends from "@babel/runtime/helpers/esm/extends";
import { fieldsIBaseModel } from './base';
import { EModel } from './model';
export let EFileUploadType;
(function (EFileUploadType) {
  EFileUploadType["PatientInsuranceImage"] = "patient-insurance-image";
  EFileUploadType["PatientMessage"] = "patient-message";
  EFileUploadType["PatientReferralFax"] = "patient-referral-fax";
  EFileUploadType["PatientReferral"] = "patient-referral";
  EFileUploadType["PatientForm"] = "patient-form";
  EFileUploadType["ProviderHeadshot"] = "provider-headshot";
  EFileUploadType["Avatar"] = "avatar";
  EFileUploadType["CustomWebStyleLogo"] = "custom-web-style-logo";
  EFileUploadType["Generic"] = "generic";
  EFileUploadType["IntegrationArchive"] = "integration-archive";
  EFileUploadType["PatientPDF"] = "patient-pdf";
  EFileUploadType["PatientCCDA"] = "patient-ccda";
  EFileUploadType["BulkPatientsInsurance"] = "bulk-patients-insurance";
  EFileUploadType["BulkPatientsForm"] = "bulk-patients-form";
  EFileUploadType["DoNotContactPatientsList"] = "do-not-contact-patients-list";
  EFileUploadType["ArchivedContactsList"] = "archived-contacts-list";
  EFileUploadType["BulkUsersUpdate"] = "bulk-users-update";
  EFileUploadType["BulkUsersCreate"] = "bulk-users-create";
  EFileUploadType["Upload"] = "upload";
  EFileUploadType["LumaBotHtmlPreview"] = "lumabot-html-preview";
  EFileUploadType["BroadcastPatientsSuccessReport"] = "broadcast-patients-success-report";
})(EFileUploadType || (EFileUploadType = {}));
export let EFileUploadStatus;
(function (EFileUploadStatus) {
  EFileUploadStatus["Processing"] = "processing";
  EFileUploadStatus["Completed"] = "completed";
  EFileUploadStatus["Failed"] = "failed";
})(EFileUploadStatus || (EFileUploadStatus = {}));
export const fieldsFileUpload = _extends({}, fieldsIBaseModel, {
  allowedSquigglies: {
    type: 'Text',
    array: true
  },
  awsId: {
    type: 'Text'
  },
  broadcast: {
    type: 'ID',
    ref: EModel.Broadcast
  },
  bucket: {
    type: 'Text'
  },
  contentType: {
    type: 'Text'
  },
  extension: {
    type: 'Text'
  },
  insurance: {
    type: 'ID',
    ref: EModel.Insurance
  },
  insurances: {
    type: 'ID',
    ref: EModel.Insurance
  },
  message: {
    type: 'ID',
    ref: EModel.Message
  },
  name: {
    type: 'Text'
  },
  outboundReferral: {
    type: 'ID',
    ref: EModel.OutboundReferral
  },
  patient: {
    type: 'ID',
    ref: EModel.Patient
  },
  patientForm: {
    type: 'ID',
    ref: EModel.PatientForm
  },
  patientForms: {
    type: 'ID',
    ref: EModel.PatientForm
  },
  previewLines: {
    type: 'Unknown',
    array: true
  },
  referral: {
    type: 'ID',
    ref: EModel.Referral
  },
  status: {
    type: 'Option',
    values: EFileUploadStatus
  },
  type: {
    type: 'Option',
    values: EFileUploadType
  },
  website: {
    type: 'Text'
  }
});